/* Swankymat style swatches: the two hover behaviours Swatch King provided.
   Everything else (the swatches themselves, the links, the size carry-over)
   is rendered server-side in Liquid, so this file has no work to do on load
   and nothing breaks if it fails. Event delegation only: Dawn re-renders
   <variant-selects> on every size change, so never cache elements. */
(function () {
  if (window.__smStyleSwatchesLoaded) return;
  window.__smStyleSwatchesLoaded = true;

  var hoverable = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  if (!hoverable) return;

  function cardImages(card) {
    var media = card.querySelector('.card__media');
    if (!media) return [];
    return Array.prototype.slice.call(media.querySelectorAll('img'), 0, 2);
  }

  function remember(img) {
    if (img.dataset.smOrigSrc !== undefined) return;
    img.dataset.smOrigSrc = img.getAttribute('src') || '';
    img.dataset.smOrigSrcset = img.getAttribute('srcset') || '';
  }

  function swap(img, src, srcset) {
    if (!img || !src) return;
    remember(img);
    img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset');
  }

  function restore(img) {
    if (!img || img.dataset.smOrigSrc === undefined) return;
    img.setAttribute('src', img.dataset.smOrigSrc);
    if (img.dataset.smOrigSrcset) img.setAttribute('srcset', img.dataset.smOrigSrcset);
    else img.removeAttribute('srcset');
  }

  // 1) Collection / grid cards: hovering a colour swatch previews that
  //    colour in the card image (featured + the secondary hover image).
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('.sm-swatches--card a.sm-swatch[data-sm-src]');
    if (!a) return;
    var card = a.closest('.card-wrapper');
    if (!card) return;
    var imgs = cardImages(card);
    swap(imgs[0], a.dataset.smSrc, a.dataset.smSrcset);
    if (imgs[1]) {
      if (a.dataset.smSrc2) swap(imgs[1], a.dataset.smSrc2, a.dataset.smSrcset2);
      else swap(imgs[1], a.dataset.smSrc, a.dataset.smSrcset);
    }
    card.dataset.smPreviewing = '1';
  }, true);

  // Leaving the card puts its own images back.
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('.card-wrapper');
    if (!card || !card.dataset.smPreviewing) return;
    var to = e.relatedTarget;
    if (to && card.contains(to)) return;
    cardImages(card).forEach(restore);
    delete card.dataset.smPreviewing;
  }, true);

  // 2) Product page: hovering a colour swatch shows its name in the
  //    "Style: Dust" label, and leaving puts the current name back.
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.sm-swatches--pdp .sm-swatch[data-sm-label]');
    if (!sw) return;
    var box = sw.closest('.sm-swatches--pdp');
    var out = box && box.querySelector('[data-sm-selected]');
    if (out) out.textContent = sw.dataset.smLabel;
  }, true);

  document.addEventListener('mouseout', function (e) {
    var box = e.target.closest && e.target.closest('.sm-swatches--pdp');
    if (!box) return;
    var to = e.relatedTarget;
    if (to && box.contains(to)) return;
    var out = box.querySelector('[data-sm-selected]');
    if (out) out.textContent = out.dataset.smCurrent || out.textContent;
  }, true);
})();
